import React from "react";
import { BrowserRouter, Route, Switch } from "react-router-dom";
import PrivateRoute from "./components/common/privateRoute/PrivateRoute";
import DefaultLayout from "./layouts/DefaultLayout";
import LandingPage from "./pages/floraFaunaForm/landingPage/LandingPage";
import Login from "./pages/login/Login";
import Logout from "./pages/logout/Logout";
import PaymentCallback from "./pages/paymentCallback/PaymentCallback";
import ImportExportSection from "navigation/ImportExportSection";
import FloraFaunaForm from "./navigation/FloraFaunaForm";
import TwoFaCallBack from "./pages/dashboard/TwoFaCallBack";
import TwoFaNotVerifiedCallBack from "./pages/dashboard/TwoFaNotVerifiedCallBack";
import ApplicationSaved from "./pages/dashboard/ApplicationSaved";
import PaymentCancel from "pages/dashboard/PaymentCancel";
import { Timer } from "./components/common/timer/Timer";
import CheckApiRequests from "./CheckApiRequests";

const App = (props) => (
  <CheckApiRequests>
    <Timer>
      <BrowserRouter>
        <Switch>
          <Route
            path="/payment/success"
            exact
            component={() => PaymentCallback(props)}
          />
          <Route path="/login" exact component={() => Login(props)} />
          <Route path="/logout" exact component={() => Logout(props)} />
          <Route
            path="/payment/success"
            exact
            component={() => PaymentCallback(props)}
          />
          <Route
            path="/payment/cancel"
            exact
            component={() => (
              <DefaultLayout>
                <PaymentCancel />
              </DefaultLayout>
            )}
          />
          <Route
            path="/"
            exact
            component={() => (
              <DefaultLayout>
                <LandingPage />
              </DefaultLayout>
            )}
          />
          <PrivateRoute
            path="/servicecompletionreference/:id"
            exact
            component={() => (
              <DefaultLayout>
                <TwoFaCallBack />
              </DefaultLayout>
            )}
          />
          <Route
            path="/servicereference/:id"
            exact
            component={() => (
              <DefaultLayout>
                <TwoFaNotVerifiedCallBack />
              </DefaultLayout>
            )}
          />
          <PrivateRoute
            path={`/application-saved`}
            exact
            component={() => (
              <DefaultLayout>
                <ApplicationSaved />
              </DefaultLayout>
            )}
          />
          <>
            <ImportExportSection />
            <FloraFaunaForm />
          </>
        </Switch>
      </BrowserRouter>
    </Timer>
  </CheckApiRequests>
);

export default App;
